let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5bQ8s")).then(() => parcelRequire('2I4om'));